/**
 * This state/reducer focuses on modes that the user can change such as the soldto/payers.
 */
import * as types from '../constants/ActionTypes';

const initialState = {
  accountType: "",
  secondaryAccounts: [],
  selectedSecondaryAccount: 0,
  selectedSoldTos: [], // used for Payer Account Type
  invoiceSearchFromDate: '', //appConstants.INV_LIST_REQ_BEGIN_DATE,
  invoiceSearchToDate: '', //moment(new Date()).format('MM-DD-YYYY'),
  selectedPrimaryAccountIndex: 0,
  primaryAccounts: [],

  invoiceSearchStatus: '',
  invoiceSearchDueDateFrom: '',
  invoiceSearchDueDateTo: '',
  filter: [],
  impersonatedUserId:null,
};

export function userOptionsReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_CUSTOMER_OPTIONS: {
      return { ...state, secondaryAccounts: action.payload };
    }

    case types.UPDATE_SELECTED_CUSTOMER_VALUE: {
      return { ...state, selectedSecondaryAccount: action.payload };
    }

    case types.UPDATE_MULTI_SELECT_SOLD_TO: {
      return { ...state, selectedMultiSoldTo: action.payload };
    }

    case types.ADD_SELECTED_SOLDTO:
      return {
        ...state,
        secondaryAccounts: [...state.secondaryAccounts, action.payload]
      };

    case types.REMOVE_UN_SELECTED_SOLDTO:
      return {
        ...state,
        secondaryAccounts: [...state.secondaryAccounts, action.payload]
      };

    case types.REMOVE_ALL_SELECTED_SOLDTOS:
      return {
        ...state,
        secondaryAccounts: [...state.secondaryAccounts, action.payload]
      };

    case types.INVOICE_SEARCH_FROM_DATE:
      return { ...state, invoiceSearchFromDate: action.payload };

    case types.INVOICE_SEARCH_TO_DATE:
      return { ...state, invoiceSearchToDate: action.payload };
    
    case types.INVOICE_SEARCH_DUE_FROM_DATE:
      return { ...state, invoiceSearchDueDateFrom: action.payload };

    case types.INVOICE_SEARCH_DUE_TO_DATE:
      return { ...state, invoiceSearchDueDateTo: action.payload };

    case types.SET_SELECTED_ACCOUNT: {
        let selectedSoldTos = action.payload.setSecondary ? state.primaryAccounts[action.payload.selectedPrimaryAccountIndex].DropDownItems.map(account => account.PrimaryAcct ) : [];
        return {
        ...state,
        selectedPrimaryAccountIndex: action.payload.selectedPrimaryAccountIndex,
        selectedSoldTos: selectedSoldTos,
        secondaryAccounts: state.primaryAccounts[action.payload.selectedPrimaryAccountIndex].DropDownItems
      };
    }

    case types.GET_PRIMARY_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        primaryAccounts: action.payload.accounts,
        secondaryAccounts: action.payload.clearSecondary ? action.payload.accounts[0].DropDownItems : state.secondaryAccounts,
      };
    }

    case types.UPDATE_IMPERSONATE_USER_ID: {
      if(action.payload === ""){
        action.payload = null;
      }
      return {
        ...state,
        impersonatedUserId: action.payload,
      };
    }

    case types.ADD_SOLD_TO_TO_SELECTED: {
      let newArray = state.selectedSoldTos.slice();
      newArray.push(action.payload);
      return {
        ...state,
        selectedSoldTos: newArray
      };
    }

    case types.REMOVE_SOLD_TO_FROM_SELECTED: {
      return {
        ...state,
        selectedSoldTos: state.selectedSoldTos.filter(i => i !== action.payload)
      };
    }
    case types.SET_SELECTED_SOLD_TOS: {
      return {
        ...state,
        selectedSoldTos: action.payload
      };
    }

    case types.UPDATE_INVOICE_SEARCH_QUERY:
      return {
        ...state,
        invoiceSearchStatus: action.payload.status,
        invoiceSearchDueDateFrom: action.payload.dueDateFrom,
        invoiceSearchDueDateTo: action.payload.dueDateTo,
        invoiceSearchFromDate: action.payload.dateFrom,
        invoiceSearchToDate: action.payload.dateTo,
        filter: action.payload.filter,
      };

    case types.UPDATE_INVOICE_SEARCH_MODE:
      return {
        ...state,
      };
    case types.SET_ACCOUNT_TYPE:
      return {
        ...state,
        accountType: action.payload
      };
      
      

    default:
      return { ...state };
  }
}
